import React, { useState } from "react";

import ContentPersonalNoteForm from "./ContentPersonalNoteForm";

const formatDate = (value) => {
    if (!value) return "";
    return new Date(value).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" });
};

const formatTime = (seconds) => {
    const value = Math.max(0, Number(seconds || 0));
    const minutes = Math.floor(value / 60);
    const remaining = Math.floor(value % 60);
    return `${minutes}:${String(remaining).padStart(2, "0")}`;
};

const getContextLabel = (note) => {
    if (note.videoTimestampSeconds != null) return formatTime(note.videoTimestampSeconds);
    if (note.pdfPage != null) return `Page ${note.pdfPage}`;
    if (note.scormNodeId || note.scormNodeTitle) return note.scormNodeTitle || note.scormNodeId;
    if (note.scrollPosition != null) return `Position ${note.scrollPosition}`;
    return note.noteContextType || "GENERAL";
};

export default function ContentPersonalNoteItem({ note, context, onNavigate, onUpdate, onDelete, submitting }) {
    const [editing, setEditing] = useState(false);

    if (editing) {
        return (
            <article className="pn-note">
                <ContentPersonalNoteForm
                    context={context}
                    initialNote={note}
                    submitting={submitting}
                    onCancel={() => setEditing(false)}
                    onSubmit={async (payload) => {
                        await onUpdate?.(note.id, payload);
                        setEditing(false);
                    }}
                />
            </article>
        );
    }

    return (
        <article className="pn-note">
            <button type="button" className="pn-note-main" onClick={() => onNavigate?.(note)}>
                <div className="pn-note-top">
                    <strong>{note.noteTitle || "Note personnelle"}</strong>
                    <span>{getContextLabel(note)}</span>
                </div>
                <p>{note.noteText}</p>
                <small>{formatDate(note.createdAt)}</small>
            </button>
            <div className="pn-note-actions">
                <button type="button" className="pn-btn" onClick={() => setEditing(true)} disabled={submitting}>
                    Modifier
                </button>
                <button type="button" className="pn-btn pn-btn--danger" onClick={() => onDelete?.(note.id)} disabled={submitting}>
                    Supprimer
                </button>
            </div>
        </article>
    );
}
